import { filter, map } from 'rxjs/operators'

export const truthy = <T extends unknown>(param = true) => filter<T>((value) => !!value === param)

export const trim = () => map<string, string>((value) => value.toString().trim())
